<div class="d-flex align-items-center">
    @if (showIcon) {
    <div class="pe-1 d-flex">
        <img src="assets/icons/icons-alt/location-alt.svg" alt="Location"/>
    </div>
    }
    <p class="wrap" [class]="cssClass">
        @if (showList && countries) {
            @for (country of (listSizeBreakPoint ? (countries | slice:0:listSizeBreakPoint) : countries); track country; let last = $last) {
                {{ (country | country:format) }}{{ !last ? ', ' : '' }}
            }
            @if (listSizeBreakPoint && countries.length > listSizeBreakPoint) {
                <span class="ps-1">+{{ countries.length - listSizeBreakPoint }}</span>
            }
        }
        @else {
            <span>{{ city ?? "-" }}</span>
            <span>{{ city && countryId ? ", " : "" }}</span>
            <span>
                {{ (countryId | country:format) }}
            </span>
        }
    </p>
</div>